export const HTTP_ERROR = `An error occurred:`;
export const SERVER_CODE = `Server returned code:`;
export const ERROR_MESSAGE = `Error : `;